// extracted by mini-css-extract-plugin
module.exports = {"ToolbarDiv":"PromotionUserSelectorDialog_ToolbarDiv__E4kbv","Label":"PromotionUserSelectorDialog_Label__1CLAf"};